import React from "react";

const Minimodal = (props) => {
  return (
    <div className="mini_modal" style={props.style}>
      <p className="modal_txt">{props.modaltext}</p>
      <button onClick={props.onClick}>{props.modalbtn}</button>
      {props.cancelbtn ? (
        <button style={{ marginRight: "10px" }} onClick={props.cancelonClick}>
          {props.cancelbtn}
        </button>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default Minimodal;
